import { apiPOST } from '../../lib/api'

export type BusDriverSignInResponse = {
  result: string
  timestamp: string
}

export const busDriverSignIn = async (
  tagId: string,
  tagSerialNumber: string | undefined,
  timestamp: string
): Promise<BusDriverSignInResponse> => {
  return apiPOST<BusDriverSignInResponse>('/bus-driver/sign-in', {
    tagId,
    serialNumber: tagSerialNumber,
    timestamp,
  })
}
